import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useMst } from '../../../models/stores/Root';
import UtilityService from '../../../services/UtilityService';

export const TermsContentTestId = 'termscontent-content';

const TermsContent: React.FC = observer(() => {
  const { configuration } = useMst();
  const divRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const scrubbedTerms = configuration.labels.termsBody
      ? UtilityService.sanitizeHtml(configuration.labels.termsBody)
      : '';
    if (divRef.current) {
      divRef.current.innerHTML = scrubbedTerms;
    }
  }, [configuration.labels.termsBody]);
  return (
    <div data-testid={TermsContentTestId} className="m-4" ref={divRef}>
      {' '}
    </div>
  );
});

export default TermsContent;
